import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CountriesState } from "./countries.state";
import { listCountries } from "./countries.thunk";
import { CountriesResponse } from "./countries.types";

const initialState: CountriesState = {
  data: null,
  status: "idle",
  error: null,
};

export const countriesSlice = createSlice({
  name: "countries",
  initialState,
  reducers: {
    resetCountries: (state) => {
      state.data = null;
    },
  },
  extraReducers: (build) => {
    build
      .addCase(listCountries.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        listCountries.fulfilled,
        (state, action: PayloadAction<CountriesResponse>) => {
          state.status = "success";
          state.data = action.payload.data;
        },
      )
      .addCase(
        listCountries.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Bir hata oluştu.";
        },
      );
  },
});

export const { resetCountries } = countriesSlice.actions;

export default countriesSlice.reducer;
